export const StatusCodeLogin = {
  EMAIL_NOT_EXIST: 400,
  INCORRECT_PASSWORD: 500
};
